module.exports = __webpack_public_path__ + "static/scale-model-of-san-jose-california-324e27c2d2ec55024a650cd5eb8a12c2.png";